import { http } from './http';
import type {
  CreateAudioEventRequest,
  CreatePhotoEventRequest,
  CreateTextEventRequest,
  PageResponse,
  TimelineEventDto,
  UpdateEventRequest,
} from './types';

export const timelineApi = {
  list(
    worksiteId: string,
    page = 0,
    size = 20,
  ): Promise<PageResponse<TimelineEventDto>> {
    return http
      .get<PageResponse<TimelineEventDto>>(
        `/worksites/${worksiteId}/timeline`,
        { params: { page, size } },
      )
      .then((r) => r.data);
  },

  createText(
    worksiteId: string,
    data: CreateTextEventRequest,
  ): Promise<{ id: string }> {
    return http
      .post<{ id: string }>(`/worksites/${worksiteId}/timeline/text`, data)
      .then((r) => r.data);
  },

  createPhoto(
    worksiteId: string,
    data: CreatePhotoEventRequest,
  ): Promise<{ id: string }> {
    return http
      .post<{ id: string }>(`/worksites/${worksiteId}/timeline/photo`, data)
      .then((r) => r.data);
  },

  createAudio(
    worksiteId: string,
    data: CreateAudioEventRequest,
  ): Promise<{ id: string }> {
    return http
      .post<{ id: string }>(`/worksites/${worksiteId}/timeline/audio`, data)
      .then((r) => r.data);
  },

  update(
    worksiteId: string,
    eventId: string,
    data: UpdateEventRequest,
  ): Promise<void> {
    return http
      .put(`/worksites/${worksiteId}/timeline/${eventId}`, data)
      .then(() => undefined);
  },

  remove(worksiteId: string, eventId: string): Promise<void> {
    return http
      .delete(`/worksites/${worksiteId}/timeline/${eventId}`)
      .then(() => undefined);
  },
};
